import axios from '@/util/request'

const PREFIX = '/api/v1/user/town'

export default {
  getUserList: function () {
    return axios.get(PREFIX + '/user_list')
  },
  getTownList: function () {
    return axios.get(PREFIX + '/town_list')
  },
  queryPage: function (param) {
    return axios.get(PREFIX + '/query_page?' + Object.keys(param).map(k => k + '=' + param[k]).join('&'))
  },
  save: function (data) {
    return axios.post(PREFIX + '/save', data)
  },
  del: function (ids) {
    return axios.post(PREFIX + '/del', {
      ids: ids
    })
  }
}
